<div
  [@toggleExpanded]="isExpanded ? 'expanded' : 'collapsed'"
  (@toggleExpanded.start)="onAnimationEvent($event)"
  (@toggleExpanded.done)="onAnimationEvent($event)"
>
  <ng-content></ng-content>
</div>
